export default __webpack_public_path__ + "static/media/background-interview-illustration.6c1f01d0.png";